import {React, styled} from 'common'
import FormField from './FormField'

const FormFields = ({fields, i18n, ...p}) => {
    return (
        <Container {...p}>
            {Object.values(fields).map((field) => {
                return <FormField key={`form_field_${field?.name}`} field={field} i18n={i18n} />
            })}
        </Container>
    )
}

export default FormFields

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 10px;
`
